import { render } from "./errorPage5.vue?vue&type=template&id=63ec440b"
import script from "./errorPage5.vue?vue&type=script&lang=js"
export * from "./errorPage5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__